export default __webpack_public_path__ + "static/media/about-retinar-rotulo.e4c05faf.png";